import QRCode from 'qrcode';

export async function generateQrCodeDataUrl(text, options = {}) {
    try {
        const defaultOptions = {
            width: options.width || 200,
            margin: options.margin || 1,
            color: {
                dark: options.darkColor || '#000000',
                light: options.lightColor || '#FFFFFF',
            },
            errorCorrectionLevel: 'M',
        };
        return await QRCode.toDataURL(text, defaultOptions);
    } catch (err) {
        console.error('QR code generation error:', err);
        return null;
    }
}

export async function generateQrCodeSvg(text, options = {}) {
    try {
        const defaultOptions = {
            width: options.width || 200,
            margin: options.margin || 1,
            color: {
                dark: options.darkColor || '#000000',
                light: options.lightColor || '#FFFFFF',
            },
            errorCorrectionLevel: 'M',
        };
        return await QRCode.toString(text, { type: 'svg', ...defaultOptions });
    } catch (err) {
        console.error('QR code SVG generation error:', err);
        return null;
    }
}

export default { generateQrCodeDataUrl, generateQrCodeSvg };
